import { useEffect } from 'react';
import styled from 'styled-components';
import { IsMobile } from 'helpers/isMobile';

function Ads({ width, height, mobileWidth, mobileHeight, number = '' }) {
    const isMobile = IsMobile(820);

    useEffect(() => {
        window?.uolads?.push({
            id: isMobile ? `banner-${mobileWidth}x${mobileHeight}-${number}` : `banner-${width}x${height}-${number}`
        });
    }, [width, height, mobileWidth, mobileHeight, number, isMobile]);

    return (
        <Publicidade
            id={isMobile ? `banner-${mobileWidth}x${mobileHeight}-${number}` : `banner-${width}x${height}-${number}`}
            width={width}
            height={height}
            mobileWidth={mobileWidth}
            mobileHeight={mobileHeight}
        />
    );
}

const Publicidade = styled.div`
    width: ${({ width }) => width}px;
    background-color: none;
    text-align: center;
    text-transform: uppercase;
    height: ${({ height }) => height}px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 820px) {
        width: ${({ mobileWidth }) => mobileWidth}px;
        height: ${({ mobileHeight }) => mobileHeight}px;
    }
`;

export default Ads;
